import React from "react";
import calloutCardThemes from "@streeteasy/design-system/callout-card/constants/calloutCardThemes";
import { HorizontalCalloutCardLink } from "@streeteasy/design-system/callout-card/HorizontalCalloutCard";
import { bool } from "prop-types";

import { sellerBannerIcon } from "../../assets";
import * as S from "./styled";

const Icon = () => <img alt="" src={sellerBannerIcon.toString()} />;

const SellerBanner = ({ isRecentSearches }) => {
  const handleAnalyticsSellerBannerClick = () => {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "homepage",
      event_action: "click_sell_homepage_banner",
      event_label: "click"
    });
  };

  return (
    <S.SellerBannerContainer isRecentSearches={isRecentSearches}>
      <S.Title>Looking to sell?</S.Title>
      <HorizontalCalloutCardLink
        callToActionCopy="Get home value"
        description="See an instant estimate of its current value on your Owner Dashboard"
        headline="What’s your home worth?"
        href="/sell-your-home"
        illustration={<Icon />}
        onClick={handleAnalyticsSellerBannerClick}
        theme={calloutCardThemes.BLUE}
      />
      <S.Link href="/sell-your-home">Explore seller tools</S.Link>
    </S.SellerBannerContainer>
  );
};

SellerBanner.propTypes = {
  isRecentSearches: bool.isRequired
};

export default SellerBanner;
